import { Skeleton } from "../skeleton";

interface CardSkeletonProps {
  count?: number;
}

export function CardSkeleton({ count = 6 }: CardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="w-full min-w-[280px] sm:min-w-[320px] md:min-w-[360px] group backdrop-blur-xl border rounded-[20px] sm:rounded-[24px] p-4 sm:p-6 md:p-7 bg-white/80 border-slate-200/60  "
        >
          {/* Header Section */}
          <div className="mb-4 sm:mb-5">
            <div className="flex items-center gap-1.5 sm:gap-2 mb-2 sm:mb-3">
              <Skeleton className="h-[24px] sm:h-[28px] w-[80px] rounded-[6px] sm:rounded-[8px]" />
              <Skeleton className="h-[24px] sm:h-[28px] w-[100px] rounded-[6px] sm:rounded-[8px]" />
            </div>
            {/* Title - 2줄 높이 */}
            <div className="space-y-2">
              <Skeleton className="h-[20px] w-full rounded-[4px]" />
              <Skeleton className="h-[20px] w-[80%] rounded-[4px]" />
            </div>
          </div>

          {/* Info Section */}
          <div className="mb-4 sm:mb-5">
            <div className="backdrop-blur-sm rounded-[12px] sm:rounded-[16px] p-3 sm:p-4 bg-slate-50/50  space-y-2 sm:space-y-2.5">
              {/* Row 1: 마감일 */}
              <div className="flex items-center justify-between py-2 sm:py-2.5">
                <Skeleton className="h-4 w-[80px]" />
                <Skeleton className="h-4 w-[120px]" />
              </div>

              {/* Row 2: 등록일 */}
              <div className="flex items-center justify-between py-2 sm:py-2.5 border-b border-slate-200/50 ">
                <Skeleton className="h-4 w-[80px]" />
                <Skeleton className="h-4 w-[120px]" />
              </div>

              {/* Row 3: 견적 제출 */}
              <div className="flex items-center justify-between py-2 sm:py-2.5 border-b border-slate-200/50 ">
                <Skeleton className="h-4 w-[80px]" />
                <Skeleton className="h-4 w-[80px]" />
              </div>
            </div>
          </div>

          {/* Footer Section - Full Width Button */}
          <Skeleton className="w-full h-[44px] rounded-[12px]" />
        </div>
      ))}
    </>
  );
}

CardSkeleton.displayName = "CardSkeleton";
